module.exports = __webpack_public_path__ + "img/person.984eb179.png";